"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@mui/material");
var _react = _interopRequireDefault(require("react"));
var _Breadcrumbs = _interopRequireDefault(require("../components/Breadcrumbs"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Main = props => /*#__PURE__*/_react.default.createElement(_material.Box, {
  sx: {
    pb: 7,
    mb: '1rem'
  }
}, /*#__PURE__*/_react.default.createElement(_material.Container, null, /*#__PURE__*/_react.default.createElement(_Breadcrumbs.default, null)), /*#__PURE__*/_react.default.createElement("main", null, props.children));
Main.defaultProps = {};
var _default = exports.default = Main;